import React, { useEffect, Fragment } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';

import { initEvents } from './config';
import ErrorReset from './components/ErrorReset'
import VersionCheck from './components/VersionCheck'
import {
    constantsRequest,
    testimonialRequest,
    featuresRequest,
    bookletChecklistRequest,
} from './redux/auth/actions';
import {
    getMakesRequest,
    getBodiesRequest,
    listVehiclesRequest,
} from './redux/vehicles/actions';
import {
    listEmployeesRequest,
} from './redux/employee/actions';
import {
    getMediaTypesRequest,
    getStoreLocationsRequest,
} from './redux/vehicles/actions';
import {
    rolesRequest,
} from './redux/auth/actions';
import { RootState } from './redux';
// import "react-day-picker/style.css";


function App() {
    const dispatch = useDispatch();
    const { auth } = useSelector((state: RootState) => state.auth);
    const [isInitialized, setIsInitialized] = React.useState(false);

    useEffect(() => {
        initEvents()

        dispatch(constantsRequest());
        dispatch(featuresRequest());
        dispatch(testimonialRequest());
        dispatch(bookletChecklistRequest());
        dispatch(getMakesRequest());
        dispatch(getBodiesRequest());
        dispatch(getMediaTypesRequest());
        dispatch(listVehiclesRequest({
            filters: 'is_sold:False',
            vehicle_fields: '',
            excludes: 'is_draft:True',
            save_as: 'vehicles',
        }));

        const handleStorageChange = () => {
            if (isInitialized)
                return;

            if (localStorage.getItem("authToken")) {
                setIsInitialized(true);
                window.removeEventListener('storage', handleStorageChange);

                if (["SuperUser", "Admin"].includes(auth?.user?.role?.title || "")) {
                    dispatch(rolesRequest());
                    dispatch(getStoreLocationsRequest());

                    dispatch(
                        listEmployeesRequest({
                            filters: "user__is_staff:True",
                            members_fields: ["id", "user", "avatar", "hour_rate", "weekly_cap"].join(","),
                            excludes: "",
                        })
                    );
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);

        // Initial check
        handleStorageChange();

        return () => {
            if (!isInitialized) {
                window.removeEventListener("storage", handleStorageChange);
            }
        };
    }, [dispatch]);

    return (
        <Fragment>
            <Helmet>
                <title>TurboCar - Quality Cars, Unmatched Value, Total Reliability</title>
            </Helmet>
            <ErrorReset />
            <VersionCheck />
        </Fragment>
    )
}

export default App;